import { useCallback } from "react";
import { OrgUserRolesEnum } from "../enums/organization";
import { useAppSelector } from "./reduxHooks";
import { ModuleEnum, ToolEnum } from "../enums/app";

export const useAccessControl = () => {

  const { currentUser } = useAppSelector((state) => state.user);
  const currentUserRole = currentUser?.current_org.role as OrgUserRolesEnum;

  const hasPageAccess = useCallback((module: ModuleEnum | null, pageTool: ToolEnum) => {
    if (!module) {
      //TODO: write logic for pages not belong to fetch or echo
    } else if (module === ModuleEnum.FETCH) {
      if (pageTool === ToolEnum.METRICS) {
        return currentUser?.ui_settings?.show_analytics;
      } else if (pageTool === ToolEnum.INTERACTIVE_METRICS) {
        return currentUser?.ui_settings?.show_analytics && currentUser?.ui_settings?.show_echo
      } else if (pageTool === ToolEnum.CONTENT_GAP_REPORT) {
        return currentUser?.ui_settings?.show_cgr
      } else if (pageTool === ToolEnum.CONVERSATION_SUMMARY) {
        return currentUser?.ui_settings?.show_csr && currentUser?.ui_settings?.show_echo
      }
      //TODO: write logic for other pages belong to fetch
    } else if (module === ModuleEnum.ECHO) {
      //TODO: write logic for pages belong to echo
    }

    return false;

  }, [currentUser]);

  const checkIsAuthorizedBaedOnCurrentUserRole = (acceptedRoles: Array<OrgUserRolesEnum>) => {
    return acceptedRoles.includes(currentUserRole);
  };

  const checkIsAuthorizedBaedOnCurrentUserRoleAndOtherPermissions = (acceptedRoles: Array<OrgUserRolesEnum>, checkHasOtherPermissions: () => boolean) => {
    return checkIsAuthorizedBaedOnCurrentUserRole(acceptedRoles) && checkHasOtherPermissions();
  };

  return { checkIsAuthorizedBaedOnCurrentUserRole, checkIsAuthorizedBaedOnCurrentUserRoleAndOtherPermissions, hasPageAccess };
};

